import type { EmailFilters, EmailStatus } from '../../../lib/emailsApi';
import { DateField } from '../../ui/DateField';

interface EmailsFiltersProps {
  filters: EmailFilters;
  // Template names to offer in the dropdown (derived from the stats endpoint).
  templates: string[];
  onChange: (patch: Partial<EmailFilters>) => void;
  onClear: () => void;
}

const STATUSES: EmailStatus[] = ['SENT', 'FAILED'];

export function EmailsFilters({ filters, templates, onChange, onClear }: EmailsFiltersProps) {
  return (
    <div className="grid grid-cols-2 items-end gap-3 rounded-lg border border-gray-200 bg-white p-4 sm:flex sm:flex-wrap">
      <label className="flex flex-col text-xs font-medium text-gray-600">
        Recipient
        <input
          type="text"
          placeholder="Search email…"
          value={filters.to ?? ''}
          onChange={(e) => onChange({ to: e.target.value || undefined })}
          className="ui-input mt-1"
        />
      </label>

      <label className="flex flex-col text-xs font-medium text-gray-600">
        Template
        <select
          value={filters.template ?? ''}
          onChange={(e) => onChange({ template: e.target.value || undefined })}
          className="ui-select mt-1"
        >
          <option value="">All</option>
          {templates.map((t) => (
            <option key={t} value={t}>
              {t}
            </option>
          ))}
        </select>
      </label>

      <label className="flex flex-col text-xs font-medium text-gray-600">
        Status
        <select
          value={filters.status ?? ''}
          onChange={(e) =>
            onChange({ status: e.target.value ? (e.target.value as EmailStatus) : undefined })
          }
          className="ui-select mt-1"
        >
          <option value="">All</option>
          {STATUSES.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>
      </label>

      <label className="flex flex-col text-xs font-medium text-gray-600">
        Sent from
        <DateField
          value={filters.from ?? ''}
          onChange={(v) => onChange({ from: v || undefined })}
          className="mt-1 sm:w-40"
        />
      </label>

      <label className="flex flex-col text-xs font-medium text-gray-600">
        Sent to
        <DateField
          value={filters.dateTo ?? ''}
          onChange={(v) => onChange({ dateTo: v || undefined })}
          className="mt-1 sm:w-40"
        />
      </label>

      <button type="button" onClick={onClear} className="ui-btn-secondary col-span-2 sm:col-span-1">
        Clear filters
      </button>
    </div>
  );
}
